module.exports = __webpack_public_path__ + "static/media/user-secret.a3848f9f.svg";